import * as React from "react";
import { useState, useEffect, useContext } from "react";
import i18n from "i18n";
import { TextField } from "@material-ui/core";
import { WBSStore } from "modules/WBS/WBSStore";

const RowCode = (props) => {
  const { classes, handleCodeFocus, handleCodeBlur } = props;
  const [rowCode, setRowCode] = useState(WBSStore.selectedLine.data.rowCode);

  useEffect(() => {
    setRowCode(WBSStore.selectedLine.data.rowCode);
  }, [WBSStore.selectedLine.data.rowCode]);

  const handleChange = (e) => {
    setRowCode(e.target.value);
  };

  return (
    <>
      <TextField
        autoComplete={"off"}
        label={i18n.project.rightSideMenu.code}
        className={classes.formControl}
        value={rowCode}
        onFocus={handleCodeFocus}
        onBlur={handleCodeBlur}
        onChange={(e) => handleChange(e)}
        InputProps={{
          readOnly: false,
        }}
      />
    </>
  );
};

export default RowCode;



// WEBPACK FOOTER //
// ./src/modules/projectRightMenu/components/layouts/RowCode.tsx